import React from 'react'
import PropTypes from 'prop-types'
import { Image } from '@chatterbug/aaron'

import Card from 'src/ui/Card/Card'
import MasonryGrid from 'src/ui/MasonryGrid/MasonryGrid'
import ActivityLabel from 'src/ui/ActivityLabel/ActivityLabel'
import checkGreen from 'src/ui/assets/icons/checkGreen.svg'

import { t } from 'src/lib/i18n-react'

import UnitConceptListSkeleton from './UnitConceptListSkeleton'

const Content = ({ name, linkToItem, timesSeen }) => {
  return (
    <Card
      label={<ActivityLabel type="concept" />}
      title={name}
      linkUrl={linkToItem}
      footer={timesSeen > 0 && <Image src={checkGreen} />}
    />
  )
}

const UnitConceptList = ({ concepts }) => {
  return (
    <UnitConceptListSkeleton
      titleSection={t('Concepts')}
      gridSection={<MasonryGrid items={concepts} renderGridContent={Content} />}
    />
  )
}

UnitConceptList.propTypes = {
  concepts: PropTypes.array,
}

export default UnitConceptList
